module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "channel-list"
  }, _vm._l((_vm.sortedChannels), function(channel) {
    return _c('li', {
      directives: [{
        name: "loader",
        rawName: "v-loader",
        value: ({
          listen: ("channel-" + (channel.id))
        }),
        expression: "{ listen: `channel-${channel.id}` }"
      }],
      key: channel.id
    }, [_c(channel.type === 'group' ? 'channel-list-group' : 'channel-list-single', {
      tag: "component",
      attrs: {
        "channel": channel,
        "chat-states": _vm.unreadChats
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d9d39c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/ChannelList.vue
// module id = 506
// module chunks = 225